// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGNewThread = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 29 36",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#newThread__clip0_5218_10798)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.326 3.92c.438 2.038.67 4.152.674 6.323v.003c-.004 2.204-.244 4.354-.658 6.224v.012c-.105 1.002-.745 1.844-1.649 2.24.172-1.361.26-2.749.26-4.157v-.278c-.006-2.327-.256-4.596-.686-6.57l-.003-.024c-.272-2.196-1.994-3.941-4.205-4.25l.314.043c-2.896-.48-5.87-.732-8.902-.732-.191 0-.38.001-.541.003h-.009c-2.428.006-4.822.152-6.885.404l.006-.017c.356-.805 1.09-1.404 1.986-1.572l-.037.006c2.759-.463 5.592-.703 8.482-.703.2 0 .4.002.571.004.204-.003.408-.004.613-.004 2.89 0 5.726.24 8.187.661l.013.001c1.265.142 2.277 1.121 2.47 2.382zm.01.072l.006.052v-.019l-.006-.033z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M25.693 18.722l-.004.002-.018.166.022-.168zM23.205 8.04c.43 2.022.658 4.119.662 6.27v.003c-.003 2.205-.243 4.355-.657 6.225l-.001.013c-.143 1.236-1.085 2.228-2.307 2.447l.069-.01c-1.975.341-3.995.553-6.13.63l-2.17 3.757-.001.004c-.15.25-.423.418-.736.418-.312 0-.586-.168-.737-.423l-2.17-3.757-.08-.001c-2.056-.076-4.08-.287-5.79-.59l-.013-.001C1.86 22.88.836 21.872.667 20.583.23 18.556 0 16.453 0 14.296c0-2.205.24-4.353.66-6.223V8.06C.8 6.81 1.758 5.808 2.997 5.598l-.129.018c2.759-.46 5.591-.701 8.481-.701.198 0 .394 0 .563.002l.612-.003c2.891 0 5.727.24 8.188.66l.013.002c1.292.145 2.32 1.164 2.48 2.464z"
    })]
  }), /*#__PURE__*/_jsx("g", {
    clipPath: "url(#newThread__clip1_5218_10798)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M19.65 31.64h3.69v3.71c0 .359.29.65.65.65.36 0 .65-.291.65-.65v-3.69h3.69c.359 0 .65-.29.65-.65 0-.36-.291-.65-.65-.65h-3.69v-3.71c0-.359-.29-.65-.65-.65-.36 0-.65.291-.65.65v3.69h-3.69c-.359 0-.65.29-.65.65 0 .36.291.65.65.65z"
    })
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "newThread__clip0_5218_10798",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h28v28H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "newThread__clip1_5218_10798",
      children: /*#__PURE__*/_jsx("path", {
        transform: "translate(19 26)",
        d: "M0 0h10v10H0z"
      })
    })]
  })]
}));
SVGNewThread.displayName = 'SVGNewThread';
export default SVGNewThread;